import { ConfigApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useConfigAPI(): ConfigApi {
  return new ConfigApi(apiConfig);
}
